// extracted by mini-css-extract-plugin
export default {"flex":"qX","imgwrap":"rX","image":"sX","textinfo":"tX","producttitle":"uX","bolder":"vX","block":"wX","info":"xX","moredetails":"yX","whitebox":"zX","old_price":"AX","discount":"BX"};
    if(module.hot) {
      // 1743628928543
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  